export default <T>(arr: T[], func: (item: T) => number): T | undefined => {
  const min = Math.min(...arr.map(func));
  return arr.find(item => func(item) === min);
};
